import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'aa-form-msg-error',
    templateUrl: './form-msg-error.component.html',
    styleUrls: [
        './form-msg-error.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormMsgErrorComponent
{
    @Input() formGroup: FormGroup;
}
